<!--  -->
<template>
  <div >
    <div>
      <span class="span_title">{{endStationName}}</span>
    </div>

    <div v-if="direction">
      <p>
        <span class="span_props">{{direction}}</span>
      </p>
      <p>
        <span class="span_props">{{stationCountDesc}}</span>
      </p>
      <p>
        <span class="span_props">{{sendTimeDesc}}</span>
      </p>

    </div>

  </div>
</template>

<script>
import { SegmentLineItem } from '../../../../utility/tdtService/BusTransfer/Model/SegmentLineItem.js';



export default {
  name: "BusSegmentEndOverlay",
  data() {
    return {

      //线段项
      segmentItem:new SegmentLineItem(),

      curSegmentLine:null,

      endStationName: "",
      direction: null,
      stationCountDesc: null,
      sendTimeDesc: null
    };
  },

  components: {},

  computed: {},

  mounted() {


  },

  methods: {

    on_mounted(callback)
    { 
        // if(this.$mount)


    },

    init()
    { 
      if(!this.segmentItem)return;
      
        this.endStationName=this.segmentItem.stationEndName;

        let direction;
        let stationCountDesc;
        let sendTimeDesc;

        if(this.segmentItem.lines && this.segmentItem.lines.length>0)
        {   
            this.curSegmentLine=this.segmentItem.lines.objects[0];
            if(this.curSegmentLine)
            {
                this.direction=this.curSegmentLine.direction;
                this.stationCountDesc="共" + this.curSegmentLine.segmentStationCount +"站";
                if(this.curSegmentLine.SEndTime)
                {
                  this.sendTimeDesc="首末班车时间： "+ this.curSegmentLine.SEndTime;
                }
            }
        }
    }

  }
};
</script>

<style lang="scss" scoped>
  
  .div_template{

        display: block;
  }



  .span_title {
    font-weight: 700;
    font-size: 14px;
    
    border-bottom: 1px solid #ccc;
    padding: 5px 0;
    font-size: 12px;
    margin: 10px 0;
}




.span_props {
    font-size: 12px;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    margin: 10px 0;
}


</style>

